import { CuratedPlaceOfSafetySchema } from "@thalamos/common";
import { trustA } from "./trusts.js";
export const placeOfSafetyOne = CuratedPlaceOfSafetySchema.parse({
    id: "14a89516-d194-49df-bf62-35ed4c2dd936",
    name: "Place of Safety One",
    address: "1 Test Street, Test Town, Test County",
    postalCode: "TE5 1NG",
    posType: "emergencyDepartment",
    organisationId: "ecdb8780-301b-4c92-b91d-abf75fc2e43b", // Lambeth Hospital
    odsCode: "ODS_1",
    config: {
        s136ExtensionFormEnabled: true,
        outcomeFormEnabled: true,
    },
    trustId: trustA.id,
    trustName: trustA.name,
});
export const placeOfSafetyTwo = CuratedPlaceOfSafetySchema.parse({
    id: "2ed89ecd-4f00-4bb6-acd8-d12ecbe9fa63",
    name: "Place of Safety Two",
    address: "2 Test Street, Test Town, Test County",
    postalCode: "TE5 1NG",
    posType: "careHome",
    odsCode: "ODS_2",
    config: {
        s136ExtensionFormEnabled: true,
        outcomeFormEnabled: true,
    },
});
/**
 * Curated places of safety mirrored from the production dataset so local/dev
 * and e2e environments search a realistic list. Smart punctuation has been
 * folded to ASCII. `trustId` and `organisationId` are deliberately omitted:
 * the production values reference trusts/organisations that are not seeded
 * locally and both are enforced foreign keys.
 *
 * Mirrored from the production places_of_safety SQL Lab export (2026-07-01).
 */
const realPlacesOfSafetyRaw = [
    {
        id: "5961dccd-5bf7-45e9-8ce5-f25498fde0ac",
        name: "Bryngofal Ward",
        address: "Prince Philip Hospital, Llanelli",
        postalCode: "SA14 8QF",
        posType: "hbPos136",
        odsCode: "7A2AL",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "5d8f1fad-97bd-492e-85c8-325e734cce0b",
        name: "Basingstoke and North Hampshire Hospital (A&E)",
        address: "Aldermaston Road, Basingstoke",
        postalCode: "RG24 9NA",
        posType: "emergencyDepartment",
        odsCode: "RN506",
    },
    {
        id: "95d93f8b-25c4-4a2e-8b6f-9af4233c0c15",
        name: "Alder Hey Children's Hospital (A&E)",
        address: "Eaton Road, Liverpool",
        postalCode: "L122AP",
        posType: "emergencyDepartment",
        odsCode: "RBS25",
    },
    {
        id: "91eb6a40-c59e-46d6-b8ac-4236d5c68888",
        name: "CPFT S136 Suite (s136 Suite), Fulbourn Hospital",
        address: "Fulbourn Hospital, Cambridge Road, Fulbourn, Cambridge",
        postalCode: "CB21 5EF",
        posType: "hbPos136",
        odsCode: "RT113",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "1cc6a2f3-3527-472f-9ed5-bbc0f0b71418",
        name: "Parkland House (s136 Suite), Royal Oldham Hospital",
        address: "Rochdale Road, Oldham, Lancs",
        postalCode: "OL1 2JH",
        posType: "hbPos136",
        odsCode: "RT203",
    },
    {
        id: "5b2d9aa3-15c8-4f86-920d-92c31f943ec5",
        name: "Royal Albert Edward Infirmary (A&E), Wigan",
        address: "Wigan Lane, Wigan, Lancs",
        postalCode: "WN1 2NN",
        posType: "emergencyDepartment",
        odsCode: "RRF02",
    },
    {
        id: "92fad821-63ba-4c26-aba9-7be331c1b468",
        name: "Buckton Building (s136 Suite), Tameside General Hospital",
        address: "Fountain Street, Ashton-under-Lyne",
        postalCode: "OL6 9RW",
        posType: "hbPos136",
        odsCode: "RT2AN",
    },
    {
        id: "92e0bf5f-1f02-4c94-a200-388519901f83",
        name: "Hinchingbrooke Hospital (A&E)",
        address: "Hinchingbrooke Park Rd, Huntingdon",
        postalCode: "PE29 6NT",
        posType: "emergencyDepartment",
        odsCode: "RGN80",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "8e4d5e50-469a-4e7c-a71e-c56cc6c6ba24",
        name: "Countess of Chester Hospital (A&E)",
        address: "The Countess of Chester Health Park, Liverpool Road, Chester",
        postalCode: "CH21UL",
        posType: "emergencyDepartment",
        odsCode: "RJR05",
    },
    {
        id: "ada0b70d-6d83-4165-81c7-982f0b44d1cd",
        name: "Mason Unit (s136 Suite), Southmead Hospital Bristol",
        address: "Southmead Hospital, Bristol",
        postalCode: "BS10 5NB",
        posType: "hbPos136",
        odsCode: "RVN3N",
    },
    {
        id: "ae7ca5cb-63de-4d31-850e-cd1ef17a5876",
        name: "Bluebell Unit (s136 Suite), Green Lane Hospital",
        address: "Bluebell Unit, Green Lane Hospital, Marshall Road, Devizes",
        postalCode: "SN10 5DS",
        posType: "hbPos136",
        odsCode: "RVNW2",
    },
    {
        id: "62f96af1-4a66-4ca5-9dc0-03592e790c5e",
        name: "Luton & Dunstable University Hospital (A&E)",
        address: "Lewsey Road, Luton, Bedfordshire",
        postalCode: "LU4 0DZ",
        posType: "emergencyDepartment",
        odsCode: "RC971",
    },
    {
        id: "d6051489-f886-4cb2-abf3-cd79a8d8a57b",
        name: "The Royal Bolton Hospital (A&E)",
        address: "Minerva Road, Bolton",
        postalCode: "BL4 0JR",
        posType: "emergencyDepartment",
        odsCode: "RMCA5",
    },
    {
        id: "de8a2a01-95fd-4f92-8404-37ecca60b41d",
        name: "Hollins Park (s136 Suite), Hollins Park Hospital",
        address: "Hollins Park Hospital, Hollins Lane, Winwick, Warrington",
        postalCode: "WA2 8WA",
        posType: "hbPos136",
        odsCode: "D4A4S",
    },
    {
        id: "fd52105b-2324-4aa0-b1cb-b8a68bfb7677",
        name: "Mere Suite (s136 Suite), Hartley Hospital",
        address: "Hartley Hospital, 1B Curzon Road, Southport",
        postalCode: "PR8 6PL",
        posType: "hbPos136",
        odsCode: "RW40A",
    },
    {
        id: "746e3270-bf49-429a-9b65-57f17274fa7d",
        name: "Wythenshawe Hospital (A&E)",
        address: "Southmoor Road, Manchester",
        postalCode: "M23 9LT",
        posType: "emergencyDepartment",
        odsCode: "R0A07",
    },
    {
        id: "02520821-8ac0-469a-bff1-93c8205cb9db",
        name: "Royal Liverpool (s136 Suite), Royal Liverpool University Hospital",
        address: "Mount Vernon Street, Liverpool",
        postalCode: "L7 8YE",
        posType: "hbPos136",
        odsCode: "REMRQ",
    },
    {
        id: "5a1db1ed-11cf-4dad-8b77-582371ec23ab",
        name: "Knowsley Resource and Recovery Centre (KRRC) (s136 Suite), Whiston Hospital",
        address: "Whiston Hospital, Warrington Road, Rainhill, Prescot",
        postalCode: "L35 5DR",
        posType: "hbPos136",
        odsCode: "D6B5D",
    },
    {
        id: "2ded68ed-83b5-4606-abca-3397f26f6138",
        name: "Royal Liverpool Hospital (A&E)",
        address: "Mount Vernon Street, Liverpool",
        postalCode: "L7 8YE",
        posType: "emergencyDepartment",
        odsCode: "REMRQ",
    },
    {
        id: "f518f8db-ca28-4e40-bf0f-6899ff861de3",
        name: "Fairfield General Hospital (A&E)",
        address: "Rochdale Old Road, Bury",
        postalCode: "BL9 7TD",
        posType: "emergencyDepartment",
        odsCode: "RM315",
    },
    {
        id: "19d6261d-6745-4368-a519-0439331e75c3",
        name: "Stepping Hill Hospital (A&E), Stockport",
        address: "Poplar Grove, Hazel Grove, Stockport",
        postalCode: "SK2 7JE",
        posType: "emergencyDepartment",
        odsCode: "RWJ09",
    },
    {
        id: "7d9f7091-cdab-49ca-8d93-7c989eb8cc5f",
        name: "Southport and Formby District General Hospital (A&E)",
        address: "Town Lane, Kew, Southport",
        postalCode: "PR8 6PN",
        posType: "emergencyDepartment",
        odsCode: "RBN51",
    },
    {
        id: "c3225c1d-f941-4282-b46a-e42bad9f1a13",
        name: "Irwell Unit (s136 Suite), Fairfield General Hospital",
        address: "Rochdale Old Road, Bury",
        postalCode: "BL9 7TD",
        posType: "hbPos136",
        odsCode: "RT248",
    },
    {
        id: "f2b90d0d-cdbf-437a-9039-bb06e65e5144",
        name: "Royal Oldham Hospital (A&E)",
        address: "Rochdale Road, Oldham, Lancs",
        postalCode: "OL1 2JH",
        posType: "emergencyDepartment",
        odsCode: "RM317",
    },
    {
        id: "9b3f7d36-95bb-4f7b-8202-a20def4ed8e5",
        name: "University Hospital Aintree (A&E)",
        address: "Lower Lane, Fazakerley, Liverpool",
        postalCode: "L9 7AL",
        posType: "emergencyDepartment",
        odsCode: "REM21",
    },
    {
        id: "50b7d8fa-a115-4f8d-aae5-d8ed8f5778fb",
        name: "Darent Valley Hospital (A&E)",
        address: "Darenth Wood Road, Dartford, Kent",
        postalCode: "DA2 8DA",
        posType: "emergencyDepartment",
        odsCode: "RN707",
    },
    {
        id: "39683fcc-b0bc-481e-8d6b-0e17c967be47",
        name: "North Manchester General Hospital (A&E)",
        address: "Delaunays Road, Manchester",
        postalCode: "M8 5RB",
        posType: "emergencyDepartment",
        odsCode: "R0A66",
    },
    {
        id: "482f44b2-7530-46f5-90de-371339745770",
        name: "Ormskirk and District General Hospital (A&E)",
        address: "Hilldale, Ormskirk",
        postalCode: "L392JW",
        posType: "emergencyDepartment",
        odsCode: "RBN52",
    },
    {
        id: "b773d237-3c5e-47dc-8068-d11e4b1868fd",
        name: "Whiston Hospital (A&E)",
        address: "Warrington Road, Prescot, Liverpool",
        postalCode: "L35 5DR",
        posType: "emergencyDepartment",
        odsCode: "F9O5Y",
    },
    {
        id: "1c429ba4-24e1-4e0b-b573-eaac005a6dfa",
        name: "Prenton Suite (s136 Suite), Clock View Hospital",
        address: "Clock View Hospital, 2A Oakhouse Park, Walton, Liverpool",
        postalCode: "L9 1EP",
        posType: "hbPos136",
        odsCode: "RW41E",
    },
    {
        id: "b00e085a-bd4c-49fb-ab58-5d0997198601",
        name: "Salford Royal Hospital (A&E)",
        address: "Meadowbrook, Stott Lane, Salford",
        postalCode: "M6 8HD",
        posType: "emergencyDepartment",
        odsCode: "RM301",
    },
    {
        id: "13e83b79-a516-4262-9976-23ccd9fcbde0",
        name: "Manchester Royal Infirmary (A&E)",
        address: "Oxford Road, Manchester",
        postalCode: "M13 9WL",
        posType: "emergencyDepartment",
        odsCode: "R0A02",
    },
    {
        id: "3e9523d6-b5a3-448f-98ff-b7070dff4dd5",
        name: "Warrington Hospital (A&E)",
        address: "Lovely Lane, Warrington",
        postalCode: "WA51QG",
        posType: "emergencyDepartment",
        odsCode: "RWWWH",
    },
    {
        id: "a4f7f00b-77c5-4bb6-ba3a-f36a3b3e8a14",
        name: "Arrowe Park Hospital (A&E)",
        address: "Arrow Park Hospital, Upton Road, Wirral",
        postalCode: "CH495PE",
        posType: "emergencyDepartment",
        odsCode: "RBL14",
    },
    {
        id: "f7f92fd7-a0cd-4cb4-b50d-32c18df8e6dc",
        name: "Aintree (s136 Suite), University Hospital Aintree",
        address: "Lower Lane, Fazakerley, Liverpool",
        postalCode: "L9 7AL",
        posType: "hbPos136",
        odsCode: "REM21",
    },
    {
        id: "9bba0298-369a-46d7-b247-56d31b4bb6c9",
        name: "Rivington Unit (s136 Suite), The Royal Bolton Hospital",
        address: "Minerva Road, Bolton",
        postalCode: "BL4 0JR",
        posType: "hbPos136",
        odsCode: "RXVF1",
    },
    {
        id: "9840c3a2-e256-4f5b-9312-3f2523d06029",
        name: "Meadowbrook Mental Health Unit (s136 Suite), Salford Royal Hospital",
        address: "Stott Lane, Salford",
        postalCode: "M6 8HD",
        posType: "hbPos136",
        odsCode: "RXV17",
    },
    {
        id: "33b509f9-263a-4e93-834d-34ef146f511c",
        name: "Atherleigh Park (s136 Suite), Atherleigh Park Hospital",
        address: "Atherleigh Way, Leigh",
        postalCode: "WN7 1YN",
        posType: "hbPos136",
        odsCode: "RXVX3",
    },
    {
        id: "7ec01907-5eed-4857-8a00-05069802e6e5",
        name: "Macclesfield District General Hospital (A&E)",
        address: "Victoria Road, Macclesfield",
        postalCode: "SK10 3BL",
        posType: "emergencyDepartment",
        odsCode: "RJN71",
    },
    {
        id: "9b945f18-6da6-45e9-b74b-48fdd446bb2d",
        name: "Caludon Centre (s136 Suite), Coventry",
        address: "Caludon Centre, Clifford Bridge Road, Coventry",
        postalCode: "CV2 2TE",
        posType: "hbPos136",
        odsCode: "RYGHQ",
    },
    {
        id: "8e3a1796-4b9d-4128-9024-3ed6f66de282",
        name: "Rochford Hospital (A&E)",
        address: "Union Lane, Rochford",
        postalCode: "SS4 1RB",
        posType: "emergencyDepartment",
        odsCode: "RAJ46",
    },
    {
        id: "50d7951b-8e9b-4aaa-9520-29db0c4ffcba",
        name: "Dorset County Hospital (A&E)",
        address: "Williams Avenue, Dorchester, Dorset",
        postalCode: "DT1 2JY",
        posType: "emergencyDepartment",
        odsCode: "RBD01",
    },
    {
        id: "ac95b134-cd75-4439-ab34-c104ba261182",
        name: "The Royal London Hospital (A&E)",
        address: "Whitechapel Road, London",
        postalCode: "E1 1FR",
        posType: "emergencyDepartment",
        odsCode: "R1H12",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "d567a6ec-7e81-4263-98e0-80b71bbc66d0",
        name: "Royal Free Hospital (A&E), London",
        address: "Pond Street, London, Greater London",
        postalCode: "NW3 2QG",
        posType: "emergencyDepartment",
        odsCode: "RAL01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "d240e272-259e-4878-856e-9c5feaacd4d8",
        name: "Whipps Cross University Hospital, (A&E), London",
        address: "Whipps Cross Road, London",
        postalCode: "E11 1NR",
        posType: "emergencyDepartment",
        odsCode: "R1HKH",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "efb40d27-f426-42af-934f-5626ea30caa3",
        name: "Furness General Hospital (A&E)",
        address: "Dalton Lane, Barrow-In-Furness, Cumbria",
        postalCode: "LA14 4LF",
        posType: "emergencyDepartment",
        odsCode: "RTXBU",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "15842b15-fbd3-403d-8138-f371d498dcfe",
        name: "Newham University Hospital (A&E), London",
        address: "Glen Road, London",
        postalCode: "E13 8SL",
        posType: "emergencyDepartment",
        odsCode: "R1HNH",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "ccccedeb-1a9b-442d-9d00-6e29d2ad4c69",
        name: "Great Western Hospital (A&E), Swindon",
        address: "Marlborough Road, Swindon",
        postalCode: "SN3 6BB",
        posType: "emergencyDepartment",
        odsCode: "RN325",
    },
    {
        id: "d4076c35-a2bd-4672-abc3-b2d780977910",
        name: "Royal Blackburn Teaching Hospital (A&E)",
        address: "Haslingden Road, Blackburn",
        postalCode: "BB2 3HH",
        posType: "emergencyDepartment",
        odsCode: "RXR20",
    },
    {
        id: "48905821-fbc8-436c-9801-78469c954f2b",
        name: "Health Based Place of Safety (s136 Suite), Littlebrook Hospital, Kent",
        address: "Bow Arrow Lane, Stone, Dartford, Kent",
        postalCode: "DA2 6PB",
        posType: "hbPos136",
        odsCode: "RXY3P",
    },
    {
        id: "4c1f8c8a-ee8b-4333-b7e9-151a5360a6ba",
        name: "North Middlesex Hospital (A&E), London",
        address: "Sterling Way, London, Greater London",
        postalCode: "N18 1QX",
        posType: "emergencyDepartment",
        odsCode: "RAL27",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "079cace3-9142-49a3-8ad8-d347ebf4b2b0",
        name: "Bradgate Mental Health Unit (s136 Suite), Glenfield Hospital, Leicester",
        address: "Glenfield Hospital Groby Road, Leicester",
        postalCode: "LE3 9EJ",
        posType: "hbPos136",
        odsCode: "RT5KF",
    },
    {
        id: "972e7e81-0df2-442c-9699-1bc756356709",
        name: "Homerton Hospital (A&E), London",
        address: "Homerton Row, London",
        postalCode: "E9 6SR",
        posType: "emergencyDepartment",
        odsCode: "RQXM1",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "c1755798-5d43-40d0-b12f-01e6e6a1e2aa",
        name: "Red Kite View (CAMHS) (s136 Suite), St Mary's Hospital, Leeds",
        address: "Green Hill Road, Armley, Leeds",
        postalCode: "LS12 3QE",
        posType: "hbPos136",
        odsCode: "RGD17",
    },
    {
        id: "1a3ecf8a-bd29-4216-bc95-8bb51b1efc64",
        name: "University College Hospital (A&E), London",
        address: "235 Euston Road, London",
        postalCode: "NW1 2BU",
        posType: "emergencyDepartment",
        odsCode: "RRV03",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "c3a51240-b04b-4c96-9be4-b14e96d201e8",
        name: "Leicester Royal Infirmary (A&E)",
        address: "Infirmary Square, Leicester",
        postalCode: "LE1 5WW",
        posType: "emergencyDepartment",
        odsCode: "RWEAA",
    },
    {
        id: "22c3e344-6fc8-4e39-ba8c-da11c9e2d3a8",
        name: "Kent and Medway Adolescent Unit (s136 Suite), Kent and Medway Adolescent Hospital",
        address: "Kent and Medway Adolescent Hospital , Cranbrook Road, Staplehurst, Tonbridge, Kent",
        postalCode: "TN12 0ER",
        posType: "hbPos136",
        odsCode: "RATPX",
    },
    {
        id: "753f9c44-ab4d-42a5-ac9c-11bd39d80e26",
        name: "Luton and Central Bedfordshire Mental Health Unit (s136 Suite), Bedfordshire",
        address: "Calnwood Road, Luton, Bedfordshire",
        postalCode: "LU4 0FB",
        posType: "hbPos136",
        odsCode: "RWK2X",
    },
    {
        id: "51f4c5ac-f0a6-4e7c-943b-f62288b1d64c",
        name: "Chorley and South Ribble Hospital (A&E)",
        address: "Preston Rd, Chorley",
        postalCode: "PR7 1PP",
        posType: "emergencyDepartment",
        odsCode: "RXN01",
    },
    {
        id: "c59055d9-a391-4d88-9511-2ed7049732e3",
        name: "Scarisbrick Centre (s136 Suite), Ormskirk Hospital",
        address: "Ormskirk Hospital, Wigan Road, Ormskirk",
        postalCode: "L39 2AZ",
        posType: "hbPos136",
        odsCode: "RW5HJ",
    },
    {
        id: "8a8cf87e-8c96-48ff-9bcf-9841a2d1d8e0",
        name: "Lister Hospital (A&E), Stevenage",
        address: "Coreys Mill Lane, Stevenage",
        postalCode: "SG1 4AB",
        posType: "emergencyDepartment",
        odsCode: "RWH01",
    },
    {
        id: "89247503-1ba8-4c39-92c1-8acf7c3e596e",
        name: "Homerton - City and Hackney Centre for Mental Health",
        address: "Homerton Row, London, Greater London",
        postalCode: "E9 6SR",
        posType: "hbPos136",
        odsCode: "RWK62",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "a59550b5-0790-41ec-90f7-cdc8acb6e20b",
        name: "The Harbour Psychiatric Unit (s136 Suite), The Harbour Hospital, Blackpool",
        address: "The Harbour, Windmill Rise (off Preston New road), Blackpool",
        postalCode: "FY4 4FE",
        posType: "hbPos136",
        odsCode: "RW5KM",
    },
    {
        id: "64b07429-03a7-4f3d-9eab-48fe1f8d91ff",
        name: "Dane Garth (s136 Suite), Furness General Hospital",
        address: "Dane Garth, Furness General Hospital Dalton Lane, Barrow-in-Furness Cumbria",
        postalCode: "LA14 4LF",
        posType: "hbPos136",
        odsCode: "RW5QS",
    },
    {
        id: "fbaf6b35-d1d4-4155-8ba2-ecb3de833d84",
        name: "Health Based Place of Safety (s136 Suite), St Martins Hospital, Kent",
        address: "Littlebourne Road, Canterbury, Kent",
        postalCode: "CT1 1AZ",
        posType: "hbPos136",
        odsCode: "RXY03",
    },
    {
        id: "2135bd04-f988-4735-9dd4-8c5357f11548",
        name: "Scunthorpe General Hospital (A&E)",
        address: "Cliff Gardens, Scunthorpe",
        postalCode: "DN15 7BH",
        posType: "emergencyDepartment",
        odsCode: "RJL32",
    },
    {
        id: "42331442-4f91-47e5-a4cd-f7aee1ccafb9",
        name: "Queen's Hospital (A&E), London",
        address: "Rom Valley Way, Romford",
        postalCode: "RM7 0AG",
        posType: "emergencyDepartment",
        odsCode: "RF4QH",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "d9543eea-9588-4ce7-9445-9a1af059e104",
        name: "Priority House (s136 Suite), Kent",
        address: "Oakwood, Hermitage Lane, Maidstone, Kent",
        postalCode: "ME16 9PH",
        posType: "hbPos136",
        odsCode: "RXY6Q",
    },
    {
        id: "2667d5d4-92a3-41b4-bc81-e80ec236674b",
        name: "Leeds General Infirmary (A&E)",
        address: "Great George St, Leeds",
        postalCode: "LS1 3EX",
        posType: "emergencyDepartment",
        odsCode: "RR801",
    },
    {
        id: "1810e625-26a4-4e53-9db5-e6c870d92318",
        name: "Lincoln County Hospital (A&E)",
        address: "Greetwell road, Lincoln",
        postalCode: "LN2 5QY",
        posType: "emergencyDepartment",
        odsCode: "RWDDA",
    },
    {
        id: "74cd2a76-0cd3-464a-9e66-7b7ffe08a272",
        name: "Royal Lancaster Infirmary (A&E)",
        address: "Ashton Road, Lancaster",
        postalCode: "LA1 4RP",
        posType: "emergencyDepartment",
        odsCode: "RTX02",
    },
    {
        id: "5573e4c6-266a-4ef6-8b12-c40403aa9273",
        name: "Watford General Hospital (A&E)",
        address: "Watford General Hospital, Vicarage Road, Watford",
        postalCode: "Wd18 0Hb",
        posType: "emergencyDepartment",
        odsCode: "RWG02",
    },
    {
        id: "fe72da45-0a52-4b92-8e83-e5366d361161",
        name: "Health Based Place of Safety (s136 Suite), Peter Hodgkinson Centre, Lincoln",
        address: "Peter Hodgkinson Centre, Greet Well Road, Lincoln",
        postalCode: "LN2 5UA",
        posType: "hbPos136",
        odsCode: "RP7EV",
    },
    {
        id: "03325dd8-8649-4005-a39b-c828a2c3b342",
        name: "St James's University Hospital (A&E)",
        address: "Beckett St, Harehills, Leeds",
        postalCode: "LS9 7TF",
        posType: "emergencyDepartment",
        odsCode: "RR813",
    },
    {
        id: "d06ea0b1-7c18-4745-8630-33c00d923bce",
        name: "Royal Preston Hospital (A&E)",
        address: "Sharoe Green Lane, Preston",
        postalCode: "PR2 9HT",
        posType: "emergencyDepartment",
        odsCode: "RXN02",
    },
    {
        id: "f4c85fb7-c915-4706-98c7-d1eeaa560a9c",
        name: "Pendle View Unit (s136 Suite), Royal Blackburn Hospital",
        address: "Pendle View, Royal Blackburn Hospital, Haslingden Rd, Blackburn",
        postalCode: "BB2 3HH",
        posType: "hbPos136",
        odsCode: "RW5RX",
    },
    {
        id: "1572c66e-4050-4a3d-9af6-295bfdb8f945",
        name: "Blackpool Victoria Hospital (A&E)",
        address: "Whinney Heys Road, Blackpool",
        postalCode: "FY3 8NR",
        posType: "emergencyDepartment",
        odsCode: "RXL01",
    },
    {
        id: "cc6c5d0f-c78d-4a8d-91c8-21fc0c1ffb79",
        name: "Health Based Place of Safety (s136 Suite), Plym Bridge House",
        address: "4 William Prance Rd, Plymouth",
        postalCode: "PL6 5ZD",
        posType: "hbPos136",
        odsCode: "NR535",
    },
    {
        id: "2eca2cd3-63b3-411f-a822-2073cc5db1db",
        name: "Health Based Place of Safety (s136 Suite), Longley Centre, Sheffield",
        address: "Health Based Place of Safety, Longley Centre, Norwood Grange Drive, Sheffield",
        postalCode: "S5 7JT",
        posType: "hbPos136",
        odsCode: "TAHCC",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "da6acce1-ded1-46f0-9d28-385615660297",
        name: "Hammersmith & Fulham Mental Health Unit (s136 Suite), London",
        address: "Claybrook Road, London",
        postalCode: "W6 8NF",
        posType: "hbPos136",
        odsCode: "RKL79",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "866e160a-78c3-4795-8c48-048b4ba06ea8",
        name: "Mental Health Unit (s136 Suite), Maudsley Hospital, London",
        address: "Denmark Hill, London, Greater London",
        postalCode: "SE5 8AZ",
        posType: "hbPos136",
        odsCode: "RV504",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "aa56230e-b009-47c7-bb09-5a37f003acbe",
        name: "St George's Hospital (A&E), London",
        address: "Blackshaw Road, Tooting, London",
        postalCode: "SW17 0QT",
        posType: "emergencyDepartment",
        odsCode: "RJ701",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "27f818c9-7f21-492a-a323-a5964cc1ed62",
        name: "St Charles Mental Health Unit (s136 Suite), London",
        address: "Exmoor Street, London",
        postalCode: "W10 6DZ",
        posType: "hbPos136",
        odsCode: "RV320",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "3b6df2d6-265b-4c92-92f4-66f1bb1b3549",
        name: "Charing Cross Hospital (A&E), London",
        address: "Fulham Palace Road, London",
        postalCode: "W6 8RF",
        posType: "emergencyDepartment",
        odsCode: "RYJ02",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "5558874b-172f-49d5-b3c8-815804f5e680",
        name: "Ealing Hospital (A&E), London",
        address: "Uxbridge Road, Southall, Middlesex",
        postalCode: "UB1 3HW",
        posType: "emergencyDepartment",
        odsCode: "R1K04",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "727b5c18-15c0-4d6e-a958-467fba845628",
        name: "King's College Hospital (Denmark Hill) (A&E), London",
        address: "Denmark Hill, London",
        postalCode: "SE5 9RS",
        posType: "emergencyDepartment",
        odsCode: "RJZ01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "b13f91df-c761-4fc7-9fae-9df47eb2527d",
        name: "Chelsea & Westminster Hospital (A&E), London",
        address: "369 Fulham Road, London",
        postalCode: "SW10 9NH",
        posType: "emergencyDepartment",
        odsCode: "RQM01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "49505787-98ac-4e6c-8b6e-b7025d86ea50",
        name: "Bristol Royal Infirmary (A&E)",
        address: "Upper Maudlin Street, Bristol",
        postalCode: "BS2 8HW",
        posType: "emergencyDepartment",
        odsCode: "RA701",
    },
    {
        id: "83810e58-671c-41f4-8fe4-a78e2ac4c580",
        name: "Lakeside Mental Health Unit (s136 Suite), London",
        address: "Twickenham Road, Isleworth, Middlesex",
        postalCode: "TW7 6AF",
        posType: "hbPos136",
        odsCode: "RKL14",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "1236c00e-19f1-4f69-9bea-f384a73503a7",
        name: "Gloucestershire Royal Hospital (A&E)",
        address: "Gloucestershire Royal Hospital, Great Western Road, Gloucester",
        postalCode: "GL1 3NN",
        posType: "emergencyDepartment",
        odsCode: "RTE03",
    },
    {
        id: "c45e9453-a6f6-499f-9f27-f8f3596d664e",
        name: "Crisis Care Suite (s136 Suite), St George's Hospital, Stafford",
        address: "St George's Hospital, Corporation St, Stafford",
        postalCode: "ST16 3SR",
        posType: "hbPos136",
        odsCode: "RRE11",
    },
    {
        id: "9f1bc532-4db8-424a-883f-6d6fda747120",
        name: "Princess Royal University Hospital (A&E), London",
        address: "Farnborough Common, Orpington, Kent",
        postalCode: "BR6 8ND",
        posType: "emergencyDepartment",
        odsCode: "RJZ30",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "f6c52b24-b7e3-43ac-9292-0ecbc340d8a5",
        name: "The Glenbourne Unit (s136 Suite), Plymouth",
        address: "The Glenbourne Unit, Morlaix Drive, Derriford, Plymouth,",
        postalCode: "PL6 5AF",
        posType: "hbPos136",
        odsCode: "NR515",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "cb014c32-cb03-4004-8b58-18d87ef97936",
        name: "Skelbrooke Ward (s136 Suite), Doncaster Adult Mental Health Unit, Doncaster",
        address: "Section 136 Suite, Skelbrooke ward, Tickhill Road Site, Balby, Doncaster",
        postalCode: "DN4 8QN",
        posType: "hbPos136",
        odsCode: "RXEA1",
    },
    {
        id: "2be49a25-3acb-4919-96d5-9b49f029ff54",
        name: "Kingfisher Ward (s136 Suite), Swallownest Court, Sheffield",
        address: "Section 136 Suite, Kingfisher Ward, Swallownest Court, Aughton Road, Sheffield",
        postalCode: "S26 4TH",
        posType: "hbPos136",
        odsCode: "RXE71",
    },
    {
        id: "d8c63c5a-f84e-408a-9c5a-73aaa86562ac",
        name: "Southmead Hospital (A&E)",
        address: "Southmead Hospital, Southmead Road, Westbury-on-Trym, Bristol",
        postalCode: "BS105NB",
        posType: "emergencyDepartment",
        odsCode: "RVJ01",
    },
    {
        id: "81fb0519-ab47-4ba2-9236-4058daa94dd4",
        name: "Tameside General Hospital (A&E)",
        address: "Fountain Street, Ashton-under-Lyne",
        postalCode: "OL6 9RW",
        posType: "emergencyDepartment",
        odsCode: "RMP01",
    },
    {
        id: "ff8f19cc-6ee4-403f-9bdb-b80837db7cfa",
        name: "St Helier Hospital (A&E), London",
        address: "Wrythe Lane, Carshalton, Surrey",
        postalCode: "SM5 1AA",
        posType: "emergencyDepartment",
        odsCode: "RVR05",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "cc98cbaf-0769-4fc4-82f1-b132c935c031",
        name: "St Mary's Hospital (A&E), London",
        address: "Praed Street, London",
        postalCode: "W2 1NY",
        posType: "emergencyDepartment",
        odsCode: "RYJ01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "a085d384-a14f-4f13-90bf-99216fb0ca36",
        name: "Crisis Care Centre (s136 Suite), Harplands Hospital, Stoke-on-Trent",
        address: "Harplands Hospital, Hilton Road, Harpfields, Stoke-on-Trent",
        postalCode: "ST4 6TH",
        posType: "hbPos136",
        odsCode: "RLY88",
    },
    {
        id: "d858e19a-335d-49a7-acfc-ab644098eb71",
        name: "Northamptonshire General Hospital (A&E)",
        address: "Northampton General Hospital, Cliftonville, Northampton",
        postalCode: "NN1 5BD",
        posType: "emergencyDepartment",
        odsCode: "RNS01",
    },
    {
        id: "348fe13c-0cf8-466e-b2b1-fce8b5de7e57",
        name: "Weston General Hospital (A&E), Weston-Super-Mare",
        address: "Weston General Hospital, Grange Road, Uphill, Weston-Super-Mare",
        postalCode: "BS23 4TQ",
        posType: "emergencyDepartment",
        odsCode: "RA7C2",
    },
    {
        id: "5d9864c1-16cd-4fee-bba8-1f94f59b86f8",
        name: "St Thomas' Hospital (A&E), London",
        address: "Westminster Bridge Road, London",
        postalCode: "SE1 7EH",
        posType: "emergencyDepartment",
        odsCode: "RJ122",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "fc4ecc51-b395-4a04-87a0-06c0a256ec5a",
        name: "County Hospital (A&E), Stafford",
        address: "County Hospital, Weston Road, Stafford",
        postalCode: "ST16 3SA",
        posType: "emergencyDepartment",
        odsCode: "RJE09",
    },
    {
        id: "3c25bd7a-caf3-4bbb-ad89-383bf22f7ff9",
        name: "Berrywood Hospital (s136 Suite), Berrywood Hospital, Northampton",
        address: "Berrywood Hopsital, Berrywood Drive, Duston, Northampton",
        postalCode: "NN5 6UD",
        posType: "hbPos136",
        odsCode: "RP1V4",
    },
    {
        id: "9af3366b-e0b3-43e4-ba4f-900d497fcfe8",
        name: "Welland Centre (s136 suite), St Mary's Hospital, Kettering",
        address: "St Mary's Hospital, 77 London Road, Kettering",
        postalCode: "NN15 7PW",
        posType: "hbPos136",
        odsCode: "RP1V5",
    },
    {
        id: "30ca5da7-a549-4d0c-b8b9-bb8072c1faf1",
        name: "Northwick Park Hospital (A&E), London",
        address: "Watford Road, Harrow, Middlesex",
        postalCode: "HA1 3UJ",
        posType: "emergencyDepartment",
        odsCode: "R1K01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "e2f4cd33-fa1c-4bd4-ba71-a48850841a3d",
        name: "Royal Cornwall Hospital (A&E)",
        address: "Royal Cornwall Hospital,Treliske Truro",
        postalCode: "TR1 3LQ",
        posType: "emergencyDepartment",
        odsCode: "REF12",
    },
    {
        id: "59688447-24b5-40ba-9e28-b13c77f12340",
        name: "Queen's Hospital Burton (A&E)",
        address: "Belvedere Rd, Burton-on-Trent",
        postalCode: "DE13 0RB",
        posType: "emergencyDepartment",
        odsCode: "RTG02",
    },
    {
        id: "bfdb14c3-b01b-4f2b-97bf-5806ae6181d8",
        name: "Maxwell Centre (s136 Suite), Wotton Lawn Hospital, Gloucester",
        address: "Maxwell Centre, Wotton Lawn Hospital, Horton road, Gloucester",
        postalCode: "GL1 3WL",
        posType: "hbPos136",
        odsCode: "RTQ02",
    },
    {
        id: "cd2237cc-3963-477e-9138-6287393a5ee8",
        name: "The Redwoods Centre (s136 Suite), Shrewsbury",
        address: "The Redwoods Centre, Somerby Drive, Bicton Heath, Shrewsbury",
        postalCode: "SY3 8DS",
        posType: "hbPos136",
        odsCode: "RRERS",
    },
    {
        id: "453de1cd-8e43-4a84-99c1-351a15a29e22",
        name: "Hellesdon (s136 Suite), Hellesdon Hospital",
        address: "Drayton High Road, Norwich",
        postalCode: "NR6 5BE",
        posType: "hbPos136",
        odsCode: "RMY01",
    },
    {
        id: "83e2e4a8-cc94-482c-ae33-f5756f19b87e",
        name: "University Hospital Lewisham (A&E), London",
        address: "Lewisham High Street, London",
        postalCode: "SE13 6LH",
        posType: "emergencyDepartment",
        odsCode: "RJ224",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "e1375a0d-0d21-4c46-8773-298ef89180ec",
        name: "Northgate (s136 Suite), Northgate Hospital",
        address: "Northgate Street, Gt Yarmouth",
        postalCode: "R30 1BU",
        posType: "hbPos136",
        odsCode: "RMY03",
    },
    {
        id: "6b710490-5292-433b-aaa1-d3bcbb9c3401",
        name: "Royal Shrewsbury Hospital (A&E), Shrewsbury",
        address: "Royal Shrewsbury Hospital, Mytton Oak Road, Shrewsbury",
        postalCode: "SY3 8XQ",
        posType: "emergencyDepartment",
        odsCode: "RXW",
    },
    {
        id: "40d68ee9-6c00-4e49-911b-460da6792502",
        name: "Queens Medical Centre (A&E), Nottingham",
        address: "Queens Medical Centre, Nottingham",
        postalCode: "NG7 2UH",
        posType: "emergencyDepartment",
        odsCode: "RX1",
    },
    {
        id: "c3d4f115-d0af-49c0-9706-27bd9829c35b",
        name: "Health Based Place of Safety (s136 Suite), Penn Hospital",
        address: "Penn Hospital, Penn Road, Wolverhampton",
        postalCode: "WV4 5HN",
        posType: "hbPos136",
        odsCode: "TAJ52",
    },
    {
        id: "c8e82eb1-35de-4ed4-8809-6f4521a75751",
        name: "Queen Elizabeth Hospital (A&E), London",
        address: "Stadium Road, London",
        postalCode: "SE18 4QH",
        posType: "emergencyDepartment",
        odsCode: "RJ231",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "c5ef2b6d-f2ba-423b-968b-fbddddead2f5",
        name: "Carsington Unit (s136 Suite), Kingsway Hospital",
        address: "Carsington Unit, Kingsway Hospital, Derby",
        postalCode: "DE22 3LZ",
        posType: "hbPos136",
        odsCode: "RXM",
    },
    {
        id: "80485879-b0a9-4a88-82fc-e4e3ca0ccc52",
        name: "The Elgar Unit (s136 Suite), Newtown Hospital",
        address: "Crisis Assessment Suite, The Elgar Unit, Newtown Hospital, Worcester",
        postalCode: "WR5 1JG",
        posType: "hbPos136",
        odsCode: "R1ADW",
    },
    {
        id: "1afa19d4-f567-4410-b8ad-12af954b66ac",
        name: "Stonebow Unit (s136 Suite), Herefordshire",
        address: "Stonebow Road, Hereford",
        postalCode: "HR1 2ER",
        posType: "hbPos136",
        odsCode: "R1AMA",
    },
    {
        id: "1c68eb3c-fb5e-4f9c-b526-3c128f925d46",
        name: "Chorley Mental Health In-patient Unit (s136 Suite), Chorley",
        address: "Chorley Mental Health In-patient Unit, Chorley & South Ribble District Hospital, Preston Road, Chorley",
        postalCode: "PR7 1PP",
        posType: "hbPos136",
        odsCode: "RW5DA",
    },
    {
        id: "193b3629-3357-4481-a1c9-d113de6046c6",
        name: "Coity Clinic (S136 Suite), Princess of Wales Hospital, Bridgend",
        address: "Coity Road, Bridgend",
        postalCode: "CF31 1RQ",
        posType: "hbPos136",
        odsCode: "7A5LA",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "f2558324-72ba-42a7-9195-51049f80b09a",
        name: "Kingston Hospital (A&E), London",
        address: "Galsworthy Road, Kingston Upon Thames, Surrey",
        postalCode: "KT2 7QB",
        posType: "emergencyDepartment",
        odsCode: "RAX01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "d3390511-ea02-400b-893c-f9c8248ff04e",
        name: "Sunflowers Court (s136 Suite), Goodmayes Hospital, London",
        address: "157 Barley Ln, Ilford",
        postalCode: "IG3 8XJ",
        posType: "hbPos136",
        odsCode: "RATGA",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "9207f2a0-4fd8-48e5-8aee-ef24edbb75c0",
        name: "Wedgwood House (s136 Suite), West Suffolk Hospital",
        address: "Wedgwood House, West Suffolk Hospital, Hardwick Lane, Bury St Edmunds, Suffolk",
        postalCode: "IP33 2QZ",
        posType: "hbPos136",
        odsCode: "RMYNR",
    },
    {
        id: "b5893f24-6bd7-4212-ba51-f17b77e22392",
        name: "Chatterton House (s136 Suite), King's Lynn",
        address: "Samphire Ward, Chatterton House, Goodwins Road, Kings Lynn",
        postalCode: "PE30 5PD",
        posType: "hbPos136",
        odsCode: "RMYWF",
    },
    {
        id: "f425ae1e-b06c-4dc6-b6de-977455911601",
        name: "Health Based Place of Safety (s136 Suite), Longreach House, Redruth",
        address: "Longreach House, Camborne/Redruth Hospital, Barncoose Terrace, Redruth",
        postalCode: "TR153ER",
        posType: "hbPos136",
        odsCode: "RJ863",
    },
    {
        id: "c6bf6228-877c-4b15-9b63-6f2bfa7c6016",
        name: "Hafan y Coed (S136 Suite), Llandough Hospital, Cardiff",
        address: "Penlan Rd, Llandough, Penarth",
        postalCode: "CF64 2XX",
        posType: "hbPos136",
        odsCode: "7A4FR",
    },
    {
        id: "3ab40d9f-d72f-4000-aa59-a28e21abbb9b",
        name: "Radbourne Unit (s36 Suite), Royal Derby Hospital",
        address: "Radbourne Unit, Royal Derby Hospital, Uttoxeter Road Derby",
        postalCode: "DE22 3WQ",
        posType: "hbPos136",
        odsCode: "RXM54",
    },
    {
        id: "63a28327-8a51-4ac8-b80a-be242f9c7ee6",
        name: "Health Based Place of Safety (s136 Suite) Bodmin Hospital",
        address: "Bodmin Hospital, Boundary Road, Bodmin",
        postalCode: "PL312QT",
        posType: "hbPos136",
        odsCode: "RJ866",
    },
    {
        id: "108e14b1-5d88-43ae-96df-c5e95e864c25",
        name: "Prince Charles Hospital (A&E), Merthyr Tydfil",
        address: "Gurnos Road, Merthyr Tydfil",
        postalCode: "CF47 9DT",
        posType: "emergencyDepartment",
        odsCode: "7A5B3",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "101a246e-2461-460f-98cb-afa0d872579d",
        name: "Cassidy Suite (s136 Suite), Highbury Hospital",
        address: "Highbury Hospital, Nottingham",
        postalCode: "NG6 9DR",
        posType: "hbPos136",
        odsCode: "RHANM",
    },
    {
        id: "8b67290f-5744-4499-94de-af0728ae385d",
        name: "Acorn Suite (s136 Suite), Sherwood Oaks Hospital",
        address: "Sherwood Oaks Hospital, Mansfield",
        postalCode: "NG18 4GW",
        posType: "hbPos136",
        odsCode: "RHAX7",
    },
    {
        id: "05f2c4a4-73e1-4a44-9a42-621c1c7d9c7a",
        name: "Highgate Mental Health Centre (s136 Suite), London",
        address: "Dartmouth Park Hill, London",
        postalCode: "N19 5NX",
        posType: "hbPos136",
        odsCode: "A4K4J",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "27832bad-d237-4ab7-a0f0-fffa46494e8f",
        name: "Princess Royal Hospital (A&E), Telford",
        address: "Princess Royal Hospital, Apley Castle, Telford",
        postalCode: "TF1 6TF",
        posType: "emergencyDepartment",
        odsCode: "RXW",
    },
    {
        id: "5a9b5950-877d-494a-ab64-2bc8012bb288",
        name: "Neath Port Talbot Hospital Mental Health Unit (S136 Suite), Port Talbot",
        address: "Baglan Way, Port Talbot",
        postalCode: "SA12 7BX",
        posType: "hbPos136",
        odsCode: "7A3CJ",
    },
    {
        id: "e4d22f02-6038-4907-8465-d61377b79548",
        name: "Barnet Hospital (A&E), London",
        address: "Wellhouse Lane, Barnet, Hertfordshire",
        postalCode: "EN5 3DJ",
        posType: "emergencyDepartment",
        odsCode: "RAL26",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "8a20d275-05ca-4248-bc95-7634ce9c3ccb",
        name: "West Park Hospital (s136 Suite), Darlington",
        address: "West Park, Edward Pease Way, Darlington",
        postalCode: "DL2 2TS",
        posType: "hbPos136",
        odsCode: "RX3MM",
    },
    {
        id: "6d013e43-030d-4e7a-a0c8-130a25f264c3",
        name: "New Cross Hospital (A&E), Wolverhampton",
        address: "New Cross Hospital, Wolverhampton Road, Wolverhampton",
        postalCode: "WV10 0QP",
        posType: "emergencyDepartment",
        odsCode: "RL403",
    },
    {
        id: "a186c576-0ba6-42ee-abcc-1e18d2159441",
        name: "Crisis Suite (S136 Suite), Prince Charles Hospital, Merthyr Tydfil",
        address: "Gurnos Road, Merthyr Tydfil",
        postalCode: "CF47 9DT",
        posType: "hbPos136",
        odsCode: "7A5B3",
    },
    {
        id: "f73485ef-8ade-45e8-b47b-188f76ab37d5",
        name: "Princess Of Wales Hospital (A&E), Bridgend",
        address: "Coity Rd, Bridgend",
        postalCode: "CF31 1RQ",
        posType: "emergencyDepartment",
        odsCode: "7A5B7",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "bb1f25ae-cf27-485c-8317-a4ae2868fa11",
        name: "Royal Glamorgan Hospital (A&E), Pontyclun",
        address: "Ynysmaerdy, Pontyclun",
        postalCode: "CF72 8XR",
        posType: "emergencyDepartment",
        odsCode: "7A5B1",
    },
    {
        id: "4446616e-954d-4140-b7b5-ffe5a27ff4a7",
        name: "University Hospital of Wales (UHW) (A&E), Cardiff",
        address: "University Hospital of Wales, Lower Ground, The Gateway, Cardiff",
        postalCode: "CF14 4XW",
        posType: "emergencyDepartment",
        odsCode: "7A4BV",
    },
    {
        id: "f8de90f0-91df-4673-b39e-0c13bbae9db1",
        name: "Health Based Place of Safety (s136 Suite), Bushey Fields Hospital",
        address: "Bushey Fields Hospital, Bushey Fields Road, Dudley",
        postalCode: "DY1 2LZ",
        posType: "hbPos136",
        odsCode: "TAJ92",
    },
    {
        id: "7532ab74-15cb-4dc8-b0c5-962fecf7c9c5",
        name: "Morriston Hospital (A&E), Swansea",
        address: "Heol Maes Eglwys, Cwmrhydyceirw, Swansea",
        postalCode: "SA6 6NL",
        posType: "emergencyDepartment",
        odsCode: "7A3C7",
    },
    {
        id: "7e0c3e99-2a32-4fb2-9524-471519fcddd0",
        name: "Health Based Place of Safety (s136 Suite), Mill View Hospital",
        address: "Nevill Avenue, Hove",
        postalCode: "BN3 7HY",
        posType: "hbPos136",
        odsCode: "RX213",
    },
    {
        id: "3fa23754-4924-42d3-8589-07d98ef676e7",
        name: "Surrey Health Based Place of Safety (s136 Suite), Farnham Road Hospital",
        address: "Farnham Road, Guildford, Surrey",
        postalCode: "GU2 7LX",
        posType: "hbPos136",
        odsCode: "RXX22",
    },
    {
        id: "e40c1db7-c448-4e74-8f4c-b23bfcdb0c79",
        name: "Worthing Hospital (A&E)",
        address: "Lyndhurst Rd, Worthing",
        postalCode: "BN11 2DH",
        posType: "emergencyDepartment",
        odsCode: "RYR18",
    },
    {
        id: "82270285-21bb-40e5-88a8-857db5ccfb56",
        name: "Heartlands Hospital (A&E), Birmingham",
        address: "Bordesley Green East, Birmingham",
        postalCode: "B9 5SS",
        posType: "emergencyDepartment",
        odsCode: "RRK97",
    },
    {
        id: "cc033fdd-351f-44b7-81cd-0b8f75156fb4",
        name: "Health Based Place of Safety (s136 Suite), Foss Park Hospital",
        address: "Foss Park Hospital, Haxby Road, York",
        postalCode: "YO31 8TA",
        posType: "hbPos136",
        odsCode: "RX3KI",
    },
    {
        id: "f914a835-ed6b-43ca-b98e-bfee0c8e553c",
        name: "St. Richards Hospital (A&E), Chichester",
        address: "Spitalfield Lane, Chichester",
        postalCode: "PO19 6SE",
        posType: "emergencyDepartment",
        odsCode: "RYR16",
    },
    {
        id: "417e01be-508d-4e6f-9ace-2431130e8e44",
        name: "Peterborough City Hospital (A&E)",
        address: "Bretton Gate, Peterborough",
        postalCode: "PE3 9GZ",
        posType: "emergencyDepartment",
        odsCode: "RGN80",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "0c1b2897-6102-448f-99a8-3486d4500dc3",
        name: "Harrison House (s136 Suite), Grimbsy",
        address: "Peaks Lane, Grimbsy",
        postalCode: "DN32 9RP",
        posType: "hbPos136",
        odsCode: "NQL10",
    },
    {
        id: "0e1c4b72-25e7-4249-8642-1472d1b3b50b",
        name: "Woodlands (s136 Suite), Hastings",
        address: "Woodlands, Conquest Hospital, The Ridge, St Leonards On Sea",
        postalCode: "TN37 7PT",
        posType: "hbPos136",
        odsCode: "RX2L6",
    },
    {
        id: "c909f541-5f2f-4724-a94a-9e9f6556db35",
        name: "Mulberry House (s136 Suite), Great Oaks",
        address: "Ashby High Street, Scunthorpe",
        postalCode: "DN16 2JX",
        posType: "hbPos136",
        odsCode: "RXE92",
    },
    {
        id: "7562dca1-1573-4756-bde3-fd9ffd2f4f2e",
        name: "Midland Metropolitan University Hospital (A&E), Sandwell and West Birmingham",
        address: "Midland Metropolitan University Hospital, Grove Lane, Smethwick",
        postalCode: "B66 2QT",
        posType: "emergencyDepartment",
        odsCode: "I3W1A",
    },
    {
        id: "c81c31e4-500e-41a7-adae-4465f058dd0b",
        name: "Prospect Park Hospital (s136 Suite), Berkshire",
        address: "Prospect Park Hospital, Honey End Lane, Tilehurst, Reading, Berkshire",
        postalCode: "RG30 4EJ",
        posType: "hbPos136",
        odsCode: "RWX51",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "0d8b3004-9ede-4ecf-bbaf-0c589574dbd8",
        name: "Health Based Place of Safety (s136 Suite), Lanchester Road Hospital",
        address: "Lanchester Road Hospital, Lanchester Road, Co Durham",
        postalCode: "DH1 5RD",
        posType: "hbPos136",
        odsCode: "RX3BB",
    },
    {
        id: "56a21336-4f3e-4b80-b227-ab1504cb12d1",
        name: "Roseberry Park Hospital (s136 Suite), Middlesbrough",
        address: "Roseberry Park, Marton Road, Middlesbrough",
        postalCode: "TS4 3AF",
        posType: "hbPos136",
        odsCode: "RX33A",
    },
    {
        id: "21ad59b5-c20f-4f60-8729-1a5914cfa988",
        name: "Health Based Place of Safety (s136 Suite), West Park Hospital",
        address: "West Park Hospital, Edward Pease Way, Darlington, Co Durham",
        postalCode: "DL2 2TS",
        posType: "hbPos136",
        odsCode: "RX39T",
    },
    {
        id: "d1f1f18b-3451-4d4e-88e9-5f45c7084db8",
        name: "Health Based Place of Safety (s136 Suite), Langley Green Hospital",
        address: "Martyrs Avenue, Crawley, West Sussex",
        postalCode: "RH11 7EJ",
        posType: "hbPos136",
        odsCode: "RX2P0",
    },
    {
        id: "6b469ef1-e2fb-4703-8f42-60f78d628cf9",
        name: "Rotherham General Hospital (A&E)",
        address: "Moorgate Road, Oakwood, Rotherham",
        postalCode: "S60 2UD",
        posType: "emergencyDepartment",
        odsCode: "RFR03",
    },
    {
        id: "14a0895e-bf10-4669-85d8-de3dc9360c8d",
        name: "Good Hope Hospital (A&E), Birmingham",
        address: "Rectory Road, Sutton Coldfield",
        postalCode: "B75 7RR",
        posType: "emergencyDepartment",
        odsCode: "RRK98",
    },
    {
        id: "2a1c0cec-3b71-46fe-b94e-5edce6bc6645",
        name: "Queen Elizabeth Hospital (A&E), Birmingham",
        address: "Mindelsohn Way, Birmingham",
        postalCode: "B15 2GW",
        posType: "emergencyDepartment",
        odsCode: "RRK15",
    },
    {
        id: "4363b929-471e-4e06-8057-2bb0498ab31b",
        name: "Royal Sussex County Hospital (A&E)",
        address: "Eastern Road, Brighton",
        postalCode: "BN2 5BE",
        posType: "emergencyDepartment",
        odsCode: "E0A3H",
    },
    {
        id: "1ab07464-33a3-41aa-953b-e363b4acad82",
        name: "Princess Royal Hospital (A&E), Sussex",
        address: "Lewes Rd, Haywards Heath",
        postalCode: "RH16 4EX",
        posType: "emergencyDepartment",
        odsCode: "N6J7V",
    },
    {
        id: "01045794-d352-422c-b2eb-6a2aaf0983dd",
        name: "Alexandra Hospital (A&E), Worcestershire",
        address: "Woodrow Drive, Redditch, Worcestershire",
        postalCode: "B98 7UB",
        posType: "emergencyDepartment",
        odsCode: "RWP01",
    },
    {
        id: "fcdd6706-c954-4f94-b0fa-6776cc9fc7e2",
        name: "James Paget University Hospital (A&E)",
        address: "Lowestoft Road, Gorleston-on-Sea, Great Yarmouth",
        postalCode: "NR31 6LA",
        posType: "emergencyDepartment",
        odsCode: "RGP75",
    },
    {
        id: "ea0f7b5f-c1ab-4e40-a460-14903821c0f3",
        name: "Cheltenham General Hospital (A&E)",
        address: "Sandford Road, Cheltenham",
        postalCode: "GL53 7AN",
        posType: "emergencyDepartment",
        odsCode: "RTE01",
    },
    {
        id: "9eeb6987-aa80-4c28-a810-55e2c6a5b22b",
        name: "Wexham Park Hospital (A&E)",
        address: "Wexham Park Hospital, Wexham St, Slough",
        postalCode: "SL2 4HL",
        posType: "emergencyDepartment",
        odsCode: "RDUA2",
    },
    {
        id: "ad38ecf8-5ea5-4af8-be03-f0263ea25447",
        name: "Crisis Assessment Suite (s136 Suite), Roseberry Park",
        address: "Roseberry Park Hospital, Middlesborough, Teesside",
        postalCode: "TS4 3AF",
        posType: "hbPos136",
        odsCode: "RX33A",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "911f5f6b-f71c-4a57-803f-f94bec1120bf",
        name: "Epsom Hospital (A&E), Surrey",
        address: "Dorking Road, Epsom, Surrey",
        postalCode: "KT18 7EG",
        posType: "emergencyDepartment",
        odsCode: "RVR50",
    },
    {
        id: "c85375ae-bf39-4217-bcd8-bdf2dd74a0ac",
        name: "Conquest Hospital (A&E), St Leonards-on-Sea",
        address: "The Ridge, St Leonards-on-Sea",
        postalCode: "TN37 7RD",
        posType: "emergencyDepartment",
        odsCode: "RXC01",
    },
    {
        id: "fbeb3ea3-6d1d-4e9c-95ea-4a9619e18816",
        name: "Bassetlaw Hospital (A&E), Nottinghamshire",
        address: "Kilton Hill, Blyth Road, Worksop, Nottinghamshire",
        postalCode: "S81 0BD",
        posType: "emergencyDepartment",
        odsCode: "RP5BA",
    },
    {
        id: "87461008-3943-4706-a226-0495d878e268",
        name: "Doncaster Royal Infirmary (A&E)",
        address: "Armthorpe Road, Doncaster",
        postalCode: "DN2 5LT",
        posType: "emergencyDepartment",
        odsCode: "RP5DR",
    },
    {
        id: "fc6f74da-11eb-4a99-83f2-3decc349d1c1",
        name: "Health Based Place of Safety (s136 Suite), Sunderland",
        address: "Hopewood Park, Waterworks Road, Ryhope, Sunderland",
        postalCode: "SR2 0NB",
        posType: "hbPos136",
        odsCode: "RX4",
    },
    {
        id: "785c71d3-ae57-4a52-ad15-bb2c93fdd003",
        name: "Hopewood Park (s136 Suite), Sunderland",
        address: "Hopewood Park, Waterworks Road, Ryhope, Sunderland",
        postalCode: "SR2 0NB",
        posType: "hbPos136",
        odsCode: "RX4Z3",
    },
    {
        id: "bf4e61ba-1a26-4b3e-a56e-075c6fa57438",
        name: "CNWL Campbell Centre HBPoS (s136 Suite)",
        address: "Hospital Campus, Standing Way, Eaglestone",
        postalCode: "MK6 5NG",
        posType: "hbPos136",
        odsCode: "RV3HD",
    },
    {
        id: "6c5e2704-16d1-484f-ae88-4b81967d1a3e",
        name: "Bradford Royal Infirmary (A&E), Bradford",
        address: "Smith Lane, Bradford",
        postalCode: "BD9 6DA",
        posType: "emergencyDepartment",
        odsCode: "RAE01",
    },
    {
        id: "05a57dd2-e590-4902-b9a0-80b4d8fc1bc2",
        name: "Health Based Place of Safety (s136 Suite), Cross Lane Hospital",
        address: "Cross Lane Hospital, Scarborough",
        postalCode: "YO12 6DN",
        posType: "hbPos136",
        odsCode: "RX3LK",
    },
    {
        id: "e45929e3-a945-4069-986a-4b95801fd35a",
        name: "Meadowfield (s136 Suite), Worthing Hospital",
        address: "Arundel Road, Worthing, West Sussex",
        postalCode: "BN13 3EF",
        posType: "hbPos136",
        odsCode: "RX20Q",
    },
    {
        id: "31417797-bd9a-49a3-bf25-8c9c80202b01",
        name: "Frimley Park Hospital (A&E)",
        address: "Frimley Park Hospital, Portsmouth Rd, Frimley, Camberley",
        postalCode: "GU16 7UJ",
        posType: "emergencyDepartment",
        odsCode: "RDU01",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "f06263a1-c2e7-49b7-a8d7-bd9035ad263a",
        name: "Humber Teaching NHS Foundation Trust",
        address: "Willerby Hill, Beverley Road, Willerby, East Yorkshire",
        postalCode: "HU10 6ED",
        posType: "emergencyDepartment",
        odsCode: "RV9",
    },
    {
        id: "06ae8c79-511f-4368-844f-ca645918fc19",
        name: "Milton Keynes University Hospital (A&E)",
        address: "Standing Way, Eaglestone, Milton Keynes",
        postalCode: "MK6 5LD",
        posType: "emergencyDepartment",
        odsCode: "RD820",
    },
    {
        id: "780d06dd-4ab9-4767-8cf1-8608f70480fe",
        name: "Hull Royal Infirmary (A&E)",
        address: "Anlaby Road, Hull",
        postalCode: "HU3 2JZ",
        posType: "emergencyDepartment",
        odsCode: "RWA01",
    },
    {
        id: "a2e9748d-f02f-444d-a566-c963aebeba8e",
        name: "Diana, Princess of Wales Hospital (A&E)",
        address: "Scartho Road, Grimsby",
        postalCode: "DN33 2BA",
        posType: "emergencyDepartment",
        odsCode: "RJL30",
    },
    {
        id: "81d89797-f8dc-4a8b-b089-4c89298d8a25",
        name: "The Carleton Clinic (s136 Suite)",
        address: "Cumwhinton Drive, Carlisle, Cumbria",
        postalCode: "CA1 3SX",
        posType: "hbPos136",
        odsCode: "RX40I",
    },
    {
        id: "74b46f82-3c4d-4edc-9345-98dea80fe06a",
        name: "Barnsley Hospital (A&E)",
        address: "Gawber Road, Barnsley, South Yorkshire",
        postalCode: "S75 2EP",
        posType: "emergencyDepartment",
        odsCode: "RFFAA",
    },
    {
        id: "9539225d-0ce7-4410-820c-fbe06ffe1998",
        name: "Glan Clwyd Hospital (A&E)",
        address: "Rhuddlan Road, Bodelwyddan, Rhyl",
        postalCode: "LL18 5UJ",
        posType: "emergencyDepartment",
        odsCode: "7A1A1",
    },
    {
        id: "10530a8a-edde-4b57-8bd7-e2a7bb552552",
        name: "Tunbridge Wells Hospital (A&E)",
        address: "Tonbridge Road, Pembury, Tunbridge Wells",
        postalCode: "TN2 4QJ",
        posType: "emergencyDepartment",
        odsCode: "RWFTW",
    },
    {
        id: "29b6f8c8-c772-4a04-96f3-d741bac600fb",
        name: "Health Based Place of Safety (s136 Suite), Farnham Road Hospital",
        address: "Farnham Road Hospital, Farnham Road, Guildford, Surrey",
        postalCode: "GU2 7LX",
        posType: "hbPos136",
        odsCode: "RXX29",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "ea2b3f28-146a-42aa-a8c2-80408e6272ad",
        name: "Vaughan Thomas Ward (s136 Suite), Warneford Hospital",
        address: "Warneford Hospital, Warneford Lane, Oxford",
        postalCode: "OX3 7JX",
        posType: "hbPos136",
        odsCode: "RNU33",
    },
    {
        id: "2bafda18-4c0d-4e35-aa0d-987feaf2f4a6",
        name: "Queen Alexandra Hospital (A&E), Portsmouth",
        address: "Southwick Hill Road, Cosham, Portsmouth, Hampshire",
        postalCode: "PO6 3LY",
        posType: "emergencyDepartment",
        odsCode: "RHU03",
    },
    {
        id: "005477a5-73e3-4b87-8a5c-64ede0aa035a",
        name: "Royal Devon & Exeter Hospital (Wonford) (A&E)",
        address: "Barrack Road, Exeter, Devon",
        postalCode: "EX2 5DW",
        posType: "emergencyDepartment",
        odsCode: "RH801",
    },
    {
        id: "01245c0a-b9f9-43a7-88b5-9dcc2a2bb12e",
        name: "Royal Surrey County Hospital (A&E)",
        address: "Egerton Road, Guildford, Surrey",
        postalCode: "GU2 7XX",
        posType: "emergencyDepartment",
        odsCode: "RA201",
    },
    {
        id: "0100f39d-4b77-4d07-9c47-d61ddbc079f6",
        name: "Rowan Ward (HBPoS), Summerlands Hospital",
        address: "56 Preston Road, Yeovil",
        postalCode: "BA20 2BX",
        posType: "hbPos136",
        odsCode: "A0H9E",
    },
    {
        id: "4b3ba966-bf5b-4746-8def-655fa49c7d99",
        name: "Rydon (HBPoS), Wellsprings Hospital",
        address: "Cheddon Road, Taunton",
        postalCode: "TA2 7AZ",
        posType: "hbPos136",
        odsCode: "RH536",
    },
    {
        id: "8ca3baf0-ba83-4a8a-8ceb-969e252aea9d",
        name: "Rowan Ward 2 (HBPoS), Summerlands Hospital",
        address: "56 Preston Road, Yeovil",
        postalCode: "BA20 2BX",
        posType: "hbPos136",
        odsCode: "A0H9E",
    },
    {
        id: "ea7873a6-33d1-4fc3-ab48-248aab7d6028",
        name: "Yeovil District Hospital (A&E)",
        address: "Higher Kingston, Yeovil",
        postalCode: "BA21 4AT",
        posType: "emergencyDepartment",
        odsCode: "RH504",
    },
    {
        id: "3ad83fb9-2eef-40cf-ad7a-8f9ada02b182",
        name: "Russells Hall Hospital (A&E), Dudley",
        address: "Russells Hall Hospital, Pensnett Road, Dudley",
        postalCode: "DY1 2HQ",
        posType: "emergencyDepartment",
        odsCode: "RNA",
    },
    {
        id: "f5bf4490-fbbd-4fad-9a0a-86a52cf9ab0b",
        name: "Princess Alexandra Hospital (A&E), Harlow",
        address: "Hamstel Road, Harlow",
        postalCode: "CM20 1QX",
        posType: "emergencyDepartment",
        odsCode: "RQWAC",
    },
    {
        id: "5dd9bbff-9c15-49d3-8c5a-eb8d3b1afd2d",
        name: "Southampton General Hospital (A&E)",
        address: "Tremona Road, Southampton",
        postalCode: "SO16 6YD",
        posType: "emergencyDepartment",
        odsCode: "RHM01",
    },
    {
        id: "1de48a4e-a365-4d91-82b5-97881fdb27a7",
        name: "Royal Stoke Hospital (A&E)",
        address: "Royal Stoke Hospital, Newcastle Road, Stoke-on-Trent",
        postalCode: "ST4 6QG",
        posType: "emergencyDepartment",
        odsCode: "RJE01",
    },
    {
        id: "c34f008d-eecb-4246-85d1-00110b427408",
        name: "Derriford Hospital (A&E), Devon",
        address: "Derriford Road, Crownhill, Plymouth, Devon",
        postalCode: "PL6 8DH",
        posType: "emergencyDepartment",
        odsCode: "RK950",
    },
    {
        id: "92e5d34f-d154-407e-9f7a-e7bbd7bb4402",
        name: "Royal Alexandra Children's Hospital (A&E)",
        address: "North Dr, Brighton and Hove, Brighton",
        postalCode: "BN2 5BE",
        posType: "emergencyDepartment",
        odsCode: "G0W1C",
    },
    {
        id: "d21db7f4-4896-462e-8d6a-ecfc04a05120",
        name: "Walsall Manor Hospital (A&E), Walsall",
        address: "Walsall Manor Hospital, Moat Road, Walsall",
        postalCode: "WS2 9PS",
        posType: "emergencyDepartment",
        odsCode: "RBK02",
    },
    {
        id: "953baad6-4d6b-4cd6-956a-c19f05b348a8",
        name: "Hereford County Hospital (A&E)",
        address: "Hereford County Hospital, Stonebow Rd, Hereford",
        postalCode: "HR1 2ER",
        posType: "emergencyDepartment",
        odsCode: "RLQ01",
    },
    {
        id: "c6b3c5d5-4595-4d56-a239-feeda4cfbffc",
        name: "Becklin Centre (Adult) (s136 Suite), Leeds",
        address: "Alma Street, Leeds",
        postalCode: "LS9 7BE",
        posType: "hbPos136",
        odsCode: "RGDBL",
    },
    {
        id: "9fc504c8-fed8-4255-a710-534f3f5c2b76",
        name: "Colchester Hospital (A&E)",
        address: "Turner Rd, Colchester",
        postalCode: "CO4 5JL",
        posType: "emergencyDepartment",
        odsCode: "RDEE4",
    },
    {
        id: "3ecfb880-696e-4c59-b6f9-5bb41674e12b",
        name: "William Harvey Hospital (A&E), Ashford",
        address: "Kennington Road, Willesborough, Ashford",
        postalCode: "TN24 0LZ",
        posType: "emergencyDepartment",
        odsCode: "RVV01",
    },
    {
        id: "f70180ec-98c9-4d4c-92e6-4730b02ebc80",
        name: "Sapphire Ward (s136 Suite), Whiteleaf Centre",
        address: "Whiteleaf Centre, Bierton Road, Aylesbury",
        postalCode: "HP20 1EG",
        posType: "hbPos136",
        odsCode: "RNUGP",
    },
    {
        id: "9b0d2214-8fc0-4b24-9b0a-3bea97b864ce",
        name: "Opal Ward (s136 Suite), Whiteleaf Centre",
        address: "Whiteleaf Centre, Bierton Road, Aylesbury",
        postalCode: "HP20 1EG",
        posType: "hbPos136",
        odsCode: "RNUGP",
    },
    {
        id: "5f4b8c61-9118-4cc1-b788-b7e532734dd3",
        name: "Ruby Ward (s136 Suite), Whiteleaf Centre",
        address: "Whiteleaf Centre, Bierton Road, Aylesbury",
        postalCode: "HP20 1EG",
        posType: "hbPos136",
        odsCode: "RNUGP",
    },
    {
        id: "db3a9ad3-d0f6-4f72-940c-580960163568",
        name: "Ablett Unit (s136 Suite)",
        address: "Glan Clwyd Hospital, Rhuddlan Road, Bodelwyddan, Rhyl",
        postalCode: "LL18 5UJ",
        posType: "hbPos136",
        odsCode: "7A1F9",
    },
    {
        id: "d9b90113-8802-491c-b6a8-3dc1730b79e0",
        name: "Wrexham Maelor Hospital (A&E)",
        address: "Croesnewydd Road, Wrexham",
        postalCode: "LL13 7TD",
        posType: "emergencyDepartment",
        odsCode: "7A1A4",
    },
    {
        id: "31cce5a0-67c3-4ba8-b1ba-322b17321925",
        name: "Phoenix Ward (s136 Suite), Littlemore Hospital",
        address: "Littlemore Hospital, Sandford Road, Oxford",
        postalCode: "OX4 4XN",
        posType: "hbPos136",
        odsCode: "RNU30",
    },
    {
        id: "096abfd9-d800-495b-835a-9c1dec8d6170",
        name: "Ashurst Ward (s136 Suite), Littlemore Hospital",
        address: "Littlemore Hospital, Sandford Road, Oxford",
        postalCode: "OX4 4XN",
        posType: "hbPos136",
        odsCode: "RNU30",
    },
    {
        id: "7fc2832e-b10b-40c3-9671-1df56de52875",
        name: "Worcestershire Royal Hospital (A&E)",
        address: "Charles Hastings Way, Worcester, Worcestershire",
        postalCode: "RWP50",
        posType: "emergencyDepartment",
        odsCode: "RWP50",
    },
    {
        id: "d5bfe73a-97ec-4152-9bc6-ec71f37468ff",
        name: "Hillingdon Hospital (A&E), London",
        address: "Pield Heath Road, Uxbridge, Middlesex",
        postalCode: "UB8 3NN",
        posType: "emergencyDepartment",
        odsCode: "RAS01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "19a3d49c-faf7-46eb-98d0-3ae8ebe9abf2",
        name: "Royal Manchester Children's Hospital (A&E), Manchester",
        address: "Oxford Road, Manchester",
        postalCode: "M13 9WL",
        posType: "emergencyDepartment",
        odsCode: "R0A03",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "d43b0b6a-845b-4d29-a2d2-e340f7856e0d",
        name: "Royal Bournemouth Hospital (A&E)",
        address: "Castle Lane East, Bournemouth, Dorset",
        postalCode: "BH7 7DW",
        posType: "emergencyDepartment",
        odsCode: "R0D02",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "a66db738-4717-49a0-92c7-98bbc0416c92",
        name: "The Orchard (s136 Suite), Lancaster",
        address: "Pathfinders Drive, Ashton Road Lancaster",
        postalCode: "LA1 4JJ",
        posType: "hbPos136",
        odsCode: "RW5MQ",
    },
    {
        id: "71889119-1ada-48d3-8f4d-8804ae88fe2c",
        name: "Kettering General Hospital (A&E)",
        address: "Kettering General Hospital, Rothwell Rd, Kettering",
        postalCode: "NN16 8UZ",
        posType: "emergencyDepartment",
        odsCode: "RNQ51",
    },
    {
        id: "8474531a-83cc-441a-8c25-91c5a8e5d7d1",
        name: "Miranda House (s136 Suite), Hull",
        address: "Gladstone Street, Anlaby Road, Hull, Humberside",
        postalCode: "HU3 2RT",
        posType: "hbPos136",
        odsCode: "RV945",
    },
    {
        id: "dc0d9d76-21c1-4ac0-bf53-ad8d5576b13c",
        name: "North View (s136 Suite), North Manchester General Hospital",
        address: "Delaunays Road, Manchester",
        postalCode: "M8 5RB",
        posType: "hbPos136",
        odsCode: "RXVL9",
    },
    {
        id: "58d37d2b-c874-4d15-a489-57c0077f5a40",
        name: "Eastbourne District General Hospital (A&E)",
        address: "Kings Drive, Eastbourne",
        postalCode: "BN21 2UD",
        posType: "emergencyDepartment",
        odsCode: "RXC02",
    },
    {
        id: "fcd95755-dfd3-4f14-bea6-570483bb32cb",
        name: "Ipswich Hospital (A&E)",
        address: "Heath Road, Ipswich, Suffolk",
        postalCode: "IP4 5PD",
        posType: "emergencyDepartment",
        odsCode: "RDE03",
    },
    {
        id: "a2c7ccfd-4133-443a-90a1-361b4eef6677",
        name: "Queen Elizabeth The Queen Mother Hospital (A&E), Margate",
        address: "St Peters Road, Margate, Kent",
        postalCode: "CT9 4AN",
        posType: "emergencyDepartment",
        odsCode: "RVV09",
    },
    {
        id: "9d132c48-4300-48cd-ad6f-0454ba7a7fc1",
        name: "Health Based Place of Safety (s136 Suite), St Ann's Hospital, Dorset",
        address: "69 Haven Road, Canford Cliffs, Poole, Dorset",
        postalCode: "BH13 7LN",
        posType: "hbPos136",
        odsCode: "RDY10",
    },
    {
        id: "c7d946e4-ce0c-4305-b9c4-e1956f0644d7",
        name: "Derwent Unit (s136 Suite), Chesterfield Royal Hospital",
        address: "Derwent Unit, Chesterfield Royal Hospital, Calow, Chesterfield",
        postalCode: "S44 5BL",
        posType: "hbPos136",
        odsCode: "RXM002",
    },
    {
        id: "70bcfa22-fc0a-4ffc-be90-fb9f923874d5",
        name: "Mental Health Unit (S136 Suite), Royal Glamorgan Hospital, Llantrisant",
        address: "Ynysmaerdy, Llantrisant",
        postalCode: "CF72 8XR",
        posType: "hbPos136",
        odsCode: "7A5FH",
    },
    {
        id: "c8c8a141-b8bd-4729-bd93-f697a044fec3",
        name: "Airedale Centre for Mental Health (s136 Suite), Bradford",
        address: "Airedale Centre for Mental Health, Steeton, Keighley",
        postalCode: "BD20 6TD",
        posType: "hbPos136",
        odsCode: "TAD53",
    },
    {
        id: "b85b440b-4545-4b51-9a5e-eeafedeae386",
        name: "Health Based Place of Safety (s136 Suite), Dorothy Pattison Hospital",
        address: "Dorothy Pattison Hospital, Alumwell Close, Walsall",
        postalCode: "WS2 9XH",
        posType: "hbPos136",
        odsCode: "TAJ83",
    },
    {
        id: "0ef2dcb1-1afd-4151-ae7d-c5ef2701c3b7",
        name: "Oleaster Suite (s136 Suite), Birmingham",
        address: "6 Mindelsohn Crescent, Birmingham",
        postalCode: "B15 2SY",
        posType: "hbPos136",
        odsCode: "RXTD4",
    },
    {
        id: "84947a31-68f6-4718-a374-7db55a199fa7",
        name: "Airedale General Hospital",
        address: "Skipton Road, Steeton, Keighley",
        postalCode: "BD20 6TD",
        posType: "emergencyDepartment",
        odsCode: "RCF22",
    },
    {
        id: "d744dcae-a55e-4e71-aea2-973e58b067fd",
        name: "The Dales (s136 Suite), Calderdale Royal Hospital",
        address: "The Calderdale Royal Hospital, Huddersfield Road, Halifax",
        postalCode: "HX3 0PW",
        posType: "hbPos136",
        odsCode: "RXG41",
    },
    {
        id: "23c07449-650d-4993-8337-f349f477a03e",
        name: "Norfolk and Norwich University Hospital (A&E)",
        address: "Colney Lane, Colney, Norwich",
        postalCode: "NR4 7UY",
        posType: "emergencyDepartment",
        odsCode: "RM102",
    },
    {
        id: "925fc42d-610a-404c-a16e-594391ff0121",
        name: "Kingfisher Court (136 Suite), Kingsley Green",
        address: "Kingfisher Court, Forest Lane, Kingsley green, Harper Lane",
        postalCode: "WD7 9HQ",
        posType: "hbPos136",
        odsCode: "RWRPS",
    },
    {
        id: "7bd432e2-db96-46a4-9bf0-0f815235cfc1",
        name: "The Queen Elizabeth Hospital, King's Lynn (A&E)",
        address: "Gayton Road, King's Lynn",
        postalCode: "PE30 4ET",
        posType: "emergencyDepartment",
        odsCode: "RCX70",
    },
    {
        id: "500363fa-6cdd-44b6-bf92-747c54507b98",
        name: "Torbay Hospital (A&E), Torquay",
        address: "Newton Road, Torquay",
        postalCode: "TQ2 7AA",
        posType: "emergencyDepartment",
        odsCode: "RA901",
    },
    {
        id: "345379fe-4949-4f93-9915-980c804c17e3",
        name: "Medway Maritime Hospital (A&E), Gillingham",
        address: "Windmill Road, Gillingham",
        postalCode: "ME7 5NY",
        posType: "emergencyDepartment",
        odsCode: "RPA02",
    },
    {
        id: "0e0791d1-6a38-41f4-8546-836253149389",
        name: "Basildon University Hospital (A&E)",
        address: "Nether Mayne, Basildon, Essex",
        postalCode: "SS16 5NL",
        posType: "emergencyDepartment",
        odsCode: "RAJ12",
    },
    {
        id: "c721cb51-58b2-4748-8d4e-eed3b39ef3de",
        name: "Poole Hospital (A&E)",
        address: "Longfleet Road, Poole, Dorset",
        postalCode: "BH15 2JB",
        posType: "emergencyDepartment",
        odsCode: "R0D01",
    },
    {
        id: "14f156bc-aea0-4426-8224-d56e6a958cab",
        name: "Colchester General Hospital (A&E)",
        address: "Turner Road, Colchester",
        postalCode: "CO4 5JL",
        posType: "emergencyDepartment",
        odsCode: "RDEE4",
    },
    {
        id: "8bf15c79-2cec-43c2-8c85-b56fae0d1b3a",
        name: "Royal Berkshire Hospital (A&E)",
        address: "London Road, Reading",
        postalCode: "RG1 5AN",
        posType: "emergencyDepartment",
        odsCode: "RHW01",
    },
    {
        id: "7eb55d0d-d389-47bf-bb4d-f9f73038e90d",
        name: "Bronglais General Hospital (A&E), Aberystwyth",
        address: "Caradog Road, Aberystwyth",
        postalCode: "SY23 1ER",
        posType: "emergencyDepartment",
        odsCode: "7A2AJ",
    },
    {
        id: "85a352d2-36e1-496a-9110-8940de878348",
        name: "Glangwili General Hospital (A&E), Carmarthen",
        address: "Dolgwili Rd, Carmarthen",
        postalCode: "SA31 2AF",
        posType: "emergencyDepartment",
        odsCode: "7A2AG",
    },
    {
        id: "06171c9a-31d1-46bd-b4cd-4e450743ea16",
        name: "Withybush General Hospital (A&E), Haverfordwest",
        address: "Fishguard Road, Haverfordwest",
        postalCode: "SA61 2PZ",
        posType: "emergencyDepartment",
        odsCode: "7A2BL",
    },
    {
        id: "220c1365-f0b8-440d-8156-17b9e3075976",
        name: "Ysbyty Gwynedd (A&E), Bangor",
        address: "Bangor, Gwynedd, Wales",
        postalCode: "LL57 2PW",
        posType: "emergencyDepartment",
        odsCode: "7A1AU",
    },
    {
        id: "ddea5079-645d-413e-90a6-b525657d2a45",
        name: "Broomfield Hospital (A&E), Chelmsford",
        address: "Court Road, Chelmsford, Essex",
        postalCode: "CM1 7ET",
        posType: "emergencyDepartment",
        odsCode: "RAJ32",
    },
    {
        id: "16dea4d0-9c27-4e1a-89df-8256629df3dd",
        name: "Calderdale Royal Hospital (A&E), Halifax",
        address: "Salterhebble, Halifax, West Yorkshire",
        postalCode: "HX3 0PW",
        posType: "emergencyDepartment",
        odsCode: "RWY02",
    },
    {
        id: "182b602c-a009-460b-9f7a-bcd405a2d1c5",
        name: "Chesterfield Royal Hospital (A&E)",
        address: "Chesterfield Rd, Calow, Chesterfield",
        postalCode: "S44 5BL",
        posType: "emergencyDepartment",
        odsCode: "RFSDA",
    },
    {
        id: "f219a107-b538-4c86-98f0-1cdb2ce984e7",
        name: "Cumberland Infirmary (A&E), Carlisle",
        address: "Newtown Road, Carlisle, Cumbria",
        postalCode: "CA2 7HY",
        posType: "emergencyDepartment",
        odsCode: "RNN62",
    },
    {
        id: "0693026d-f6ea-421a-bb72-c351ef36fac5",
        name: "Darlington Memorial Hospital (A&E)",
        address: "Hollyhurst Road, Darlington",
        postalCode: "DL3 6HX",
        posType: "emergencyDepartment",
        odsCode: "RXPDA",
    },
    {
        id: "d95a2ac9-5e4e-4a28-b9d6-b099b7a6fa62",
        name: "Dewsbury and District Hospital (A&E)",
        address: "Halifax Road, Dewsbury, West Yorkshire",
        postalCode: "WF13 4HS",
        posType: "emergencyDepartment",
        odsCode: "RXF10",
    },
    {
        id: "27366f8e-8be1-4ed8-a242-6e9eb7a90306",
        name: "East Surrey Hospital (A&E), Redhill",
        address: "Canada Avenue, Redhill",
        postalCode: "RH1 5RH",
        posType: "emergencyDepartment",
        odsCode: "RTP04",
    },
    {
        id: "3046806e-79bc-4449-8733-0c6e335c9098",
        name: "George Eliot Hospital (A&E), Nuneaton",
        address: "College Street, Nuneaton, Warwickshire",
        postalCode: "CV10 7DJ",
        posType: "emergencyDepartment",
        odsCode: "RLT01",
    },
    {
        id: "4846d260-2c2e-465a-9044-e189bca14189",
        name: "Horton General Hospital (A&E), Banbury",
        address: "Oxford Road, Banbury, Oxfordshire",
        postalCode: "OX16 9AL",
        posType: "emergencyDepartment",
        odsCode: "RTH05",
    },
    {
        id: "41e8a6ca-26f2-440c-894b-98d5c6a96858",
        name: "Huddersfield Royal Infirmary (A&E)",
        address: "Acre Street, Lindley, Huddersfield",
        postalCode: "HD3 3EA",
        posType: "emergencyDepartment",
        odsCode: "RWY01",
    },
    {
        id: "937fa1fb-4488-4851-90fd-f4540771d663",
        name: "The Grange University Hospital (A&E), Cwmbran",
        address: "Caerleon Rd, Llanfrechfa, Cwmbran",
        postalCode: "NP44 8YN",
        posType: "emergencyDepartment",
        odsCode: "7A6G9",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "67c6c831-e02b-43ae-91a0-21c91362b199",
        name: "Harrogate District Hospital (A&E)",
        address: "Lancaster Park Road, Harrogate, North Yorkshire",
        postalCode: "HG2 7SX",
        posType: "emergencyDepartment",
        odsCode: "RCD01",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "0af7c9ab-51a4-410c-9abe-d6e3a5c091b4",
        name: "John Radcliffe Hospital (A&E), Headington",
        address: "Headley Way, Headington, Oxford",
        postalCode: "OX3 9DU",
        posType: "emergencyDepartment",
        odsCode: "RTH08",
    },
    {
        id: "951c411c-3801-4c22-aed7-e3c33786abb9",
        name: "Northern General Hospital (A&E), Sheffield",
        address: "Herries Road, Sheffield, South Yorkshire",
        postalCode: "S5 7AU",
        posType: "emergencyDepartment",
        odsCode: "RHQNG",
    },
    {
        id: "b44f900a-77e0-4436-8e7f-3b71631bfc3a",
        name: "Pinderfields Hospital (A&E), Wakefield",
        address: "Aberford Road, Wakefield",
        postalCode: "WF1 4DG",
        posType: "emergencyDepartment",
        odsCode: "RXF05",
    },
    {
        id: "0eea0a14-d8a1-4dc9-bc6d-92700d0c83ee",
        name: "King's Mill Hospital (A&E), Sutton-in-Ashfield",
        address: "Mansfield Road, Sutton-in-Ashfield",
        postalCode: "NG17 4JL",
        posType: "emergencyDepartment",
        odsCode: "RK5BC",
    },
    {
        id: "f4e32d39-cde4-430e-812f-a09d3733f48b",
        name: "Royal Derby Hospital (A&E), Derby",
        address: "Uttoxeter Road, Derby, Derbyshire",
        postalCode: "DE22 3NE",
        posType: "emergencyDepartment",
        odsCode: "RTGFG",
    },
    {
        id: "ab3abcb5-add8-41ec-aad0-9603002c6adb",
        name: "Stoke Mandeville Hospital (A&E), Aylesbury",
        address: "Mandeville Road, Aylesbury, Buckinghamshire",
        postalCode: "HP21 8AL",
        posType: "emergencyDepartment",
        odsCode: "RXQ02",
    },
    {
        id: "17dc4d8c-6fbb-4fd6-9bf1-8cff39a096fa",
        name: "University Hospital of North Tees (A&E), Stockton-on-Tees",
        address: "Hardwick Road, Stockton-on-Tees",
        postalCode: "TS19 8PE",
        posType: "emergencyDepartment",
        odsCode: "RVWAE",
    },
    {
        id: "54319197-868a-45ca-9cb5-4bec956be55d",
        name: "West Suffolk Hospital (A&E)",
        address: "Hardwick Lane, Bury St Edmunds, Suffolk",
        postalCode: "IP33 2QZ",
        posType: "emergencyDepartment",
        odsCode: "RGR50",
    },
    {
        id: "7fd04681-d3dd-46e1-b0eb-d1717981d3ec",
        name: "York Hospital (A&E)",
        address: "Wigginton Road, York, North Yorkshire",
        postalCode: "YO31 8HE",
        posType: "emergencyDepartment",
        odsCode: "RCB00",
    },
    {
        id: "a0d9d4e6-7e90-4b46-988c-1fc8f01ba3b9",
        name: "Crawford Suite (s136 Suite), Mossley Hill",
        address: "Mossley Hill, Park Avenue, Liverpool",
        postalCode: "L18 8BU",
        posType: "hbPos136",
        odsCode: "RW438",
    },
    {
        id: "c21f0bcd-b7a7-4968-8a34-0ce875546c02",
        name: "Health Based Place of Safety (s136 Suite), St George's Park",
        address: "St George's Park, Morpeth, Northumberland",
        postalCode: "NE61 2NU",
        posType: "hbPos136",
        odsCode: "RX4E2",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "3abba64e-33ac-4da4-9928-4cde13ef249d",
        name: "Maidstone Hospital (A&E)",
        address: "Hermitage Lane, Maidstone, Kent",
        postalCode: "ME16 9QQ",
        posType: "emergencyDepartment",
        odsCode: "RWF03",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "1450e436-f078-439c-83e9-444c4e84b86d",
        name: "University Hospital, Coventry (A&E)",
        address: "Clifford Bridge Road, Coventry",
        postalCode: "CV2 2DX",
        posType: "emergencyDepartment",
        odsCode: "RKB01",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "762409af-915d-42f9-847c-00d287b2965b",
        name: "Croydon University Hospital (A&E), London",
        address: "530 London Road, Thornton Heath, Croydon",
        postalCode: "CR7 7YE",
        posType: "emergencyDepartment",
        odsCode: "RJ611",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "33e9844b-37bf-4f32-847b-c49a29d22195",
        name: "Lotus Assessment Suite (136 Suite), Springfield University Hospital, London",
        address: "Storey Building, Springfield University Hospital, 7 Springfield Drive",
        postalCode: "SW17 0YF",
        posType: "hbPos136",
        odsCode: "RQY01",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "ae50b610-8eaf-4d74-8cf8-85783416854b",
        name: "Oxleas House (s136 Suite), Queen Elizabeth Hospital, London",
        address: "Queen Elizabeth Hospital, Stadium Road, Woolwich, London",
        postalCode: "SE18 4QH",
        posType: "hbPos136",
        odsCode: "RPGAE",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "afd25bad-b03b-49f0-b2eb-2dd8c5423305",
        name: "Riverside Centre (s136 Suite), Hillingdon Hospital, London",
        address: "Pield Heath Road, Hillingdon, Greater London",
        postalCode: "UB8 3NN",
        posType: "hbPos136",
        odsCode: "RV3AN",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "339b0724-3b5d-48f3-9b6e-e8c819304819",
        name: "The King George Hospital (A&E), London",
        address: "Barley Lane, Ilford, Essex",
        postalCode: "IG3 8YB",
        posType: "emergencyDepartment",
        odsCode: "RF4DG",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "74d9e36c-d6d1-48a6-9374-935af729db1e",
        name: "West Middlesex University Hospital (A&E), London",
        address: "Twickenham Road, Isleworth, Middlesex",
        postalCode: "TW7 6AF",
        posType: "emergencyDepartment",
        odsCode: "RQMD3",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
    {
        id: "4a067092-ed98-478d-a2bb-882b0e896f3d",
        name: "Heddfan Unit (s136 Suite), Wrexham Maelor Hospital",
        address: "Heddfan Adult Mental Health Unit, Wrexham Maelor Hospital Croesnewydd Road, Wrexham",
        postalCode: "LL13 7TD",
        posType: "hbPos136",
        odsCode: "7A1A4",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "3b98b4e5-abbf-4fac-88ca-7d0f9858db4c",
        name: "Hergest Unit (s136 Suite), Bangor",
        address: "Hergest Unit, Ysbyty Gwynedd, Ysgoborwen Road, Bangor",
        postalCode: "LL57 2PW",
        posType: "hbPos136",
        odsCode: "7A1FT",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "72599959-b493-4850-ae1a-ded0bc771c92",
        name: "St Cadoc's Hospital (s136 Suite), Newport",
        address: "Lodge Road, Caerleron, Newport",
        postalCode: "NP18 3XQ",
        posType: "hbPos136",
        odsCode: "7A6F7",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "161d6ede-15f5-42fc-bd1f-1f9dff34b89e",
        name: "Woodlands Unit (s136 Suite), Ipswich Hospital",
        address: "Ipswich Hospital, Heath Road, Ipswich, Suffolk",
        postalCode: "IP4 5PD",
        posType: "hbPos136",
        odsCode: "RMYNG",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "10de5b11-82ae-4df4-8271-b12b5f6cdb1c",
        name: "Bedfordshire Hospital (A&E), Bedford",
        address: "South Wing, Kempston Road, Bedford",
        postalCode: "MK42 9DJ",
        posType: "emergencyDepartment",
        odsCode: "RC920",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "4bcdc318-cc6b-4c56-ad54-f9271d1af708",
        name: "The James Cook University Hospital (A&E), Middlesbrough",
        address: "Marton Road, Middlesbrough",
        postalCode: "TS4 3BW",
        posType: "emergencyDepartment",
        odsCode: "RTRAT",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "d09b6db6-d533-400a-a478-a6b677d7c6d6",
        name: "Southend University Hospital (A&E), Southend-on-Sea",
        address: "Prittlewell Chase, Westcliff-on-Sea",
        postalCode: "SS0 0RY",
        posType: "emergencyDepartment",
        odsCode: "RAJ01",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "de99dac3-8179-40b1-9304-4ecf03da8402",
        name: "Health Based Place of Safety (s136 Suite), St Nicholas Hospital",
        address: "Jubilee Road, Gosforth, Newcastle upon Tyne",
        postalCode: "NE3 3XT",
        posType: "hbPos136",
        odsCode: "RX4E4",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "13dc5bf2-a7c7-4255-b2bb-f7665a98b523",
        name: "Addenbrookes Hospital (A&E)",
        address: "Hills Road, Cambridge, Cambridgeshire",
        postalCode: "CB2 0QQ",
        posType: "emergencyDepartment",
        odsCode: "RGT46",
        config: {
            s136ExtensionFormEnabled: false,
            outcomeFormEnabled: false,
        },
    },
    {
        id: "2f20efaa-2723-4739-8785-2e501a48c2e8",
        name: "The Whittington Hospital (A&E), London",
        address: "Highgate Hill, London, Greater London",
        postalCode: "N19 5NF",
        posType: "emergencyDepartment",
        odsCode: "RKEQ4",
        config: {
            s136ExtensionFormEnabled: true,
            outcomeFormEnabled: true,
        },
    },
];
export const realPlacesOfSafety = realPlacesOfSafetyRaw.map((placeOfSafety) => CuratedPlaceOfSafetySchema.parse(placeOfSafety));
export const defaultPlacesOfSafety = [
    placeOfSafetyOne,
    placeOfSafetyTwo,
    ...realPlacesOfSafety,
];
//# sourceMappingURL=placesOfSafety.js.map